/**
 * 查询展示保留报价计算的最多八位小数，零价正常显示，不提前截为两位。
 *
 * @param value 后端返回的最终卖价
 * @returns 可展示的金额，未维护时显示横线
 */
export const formatSalesQueryPrice = (value: number | string | null | undefined): string => {
  if (value === null || value === undefined || value === '' || !Number.isFinite(Number(value))) return '-'
  return String(Number(Number(value).toFixed(8)))
}
